<template>
  <v-window-item value="others">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-plus-box</v-icon>
          Other Information
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-row>
              <v-col cols="6">
                <v-card variant="outlined" class="mb-4">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-account-star</v-icon>
                    Extra Curricular Activities
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                        v-model="otherInfo.extra_curricular_activities"
                        label="Extra Curricular Activities"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        clearable
                    />
                    <v-textarea
                        v-model="otherInfo.extra_curricular_remarks"
                        label="Remarks"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        rows="3"
                        auto-grow
                        clearable
                    />
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card variant="outlined" class="mb-4">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-account-tie</v-icon>
                    Area of Specialization
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                        v-model="otherInfo.area_of_specialization"
                        label="Area of Specialization"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        clearable
                    />
                    <v-textarea
                        v-model="otherInfo.specialization_remarks"
                        label="Remarks"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        rows="3"
                        auto-grow
                        clearable
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-card variant="outlined">
              <v-card-title class="text-subtitle-1">
                <v-icon class="me-1" size="small">mdi-translate</v-icon>
                Language Proficiency
              </v-card-title>
              <v-card-text>
                <div class="language-table">
                  <v-row class="language-row language-header ma-0">
                    <v-col cols="12" md="3">Language</v-col>
                    <v-col cols="12" md="2">Writing</v-col>
                    <v-col cols="12" md="2">Reading</v-col>
                    <v-col cols="12" md="2">Speaking</v-col>
                    <v-col cols="12" md="3">Action</v-col>
                  </v-row>

                  <v-row
                    v-for="(language, index) in languageProficiencies"
                    :key="index"
                    class="language-row ma-0"
                  >
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="language.language"
                        label="Language"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        hide-details
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="language.writing"
                        :items="proficiencyLevels"
                        item-title="text"
                        item-value="value"
                        label="Writing"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="language.reading"
                        :items="proficiencyLevels"
                        item-title="text"
                        item-value="value"
                        label="Reading"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="language.speaking"
                        :items="proficiencyLevels"
                        item-title="text"
                        item-value="value"
                        label="Speaking"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        hide-details
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex align-center">
                      <v-btn
                        color="error"
                        variant="text"
                        size="small"
                        type="button"
                        :disabled="languageProficiencies.length === 1"
                        @click="removeLanguage(index)"
                      >
                        <v-icon start size="small">mdi-delete</v-icon>
                        Remove
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <v-btn
                  color="primary"
                  variant="tonal"
                  size="small"
                  type="button"
                  class="mt-3"
                  @click="addLanguage"
                >
                  <v-icon start>mdi-plus</v-icon>
                  Add More
                </v-btn>
              </v-card-text>
            </v-card>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn color="primary" type="submit" variant="flat" :loading="submitting">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const createOtherInfo = () => ({
  id: null,
  extra_curricular_activities: '',
  extra_curricular_remarks: '',
  area_of_specialization: '',
  specialization_remarks: '',
  language_proficiencies: []
});

const createLanguage = () => ({
  language: '',
  writing: '',
  reading: '',
  speaking: ''
});

export default {
  props: {
    userOthersInfoData: {
      type: Object,
      default: () => ({})
    },
    employeeId: {
      default: null
    }
  },
  data: () => ({
    proficiencyLevels: [
      { text: 'Beginner', value: 'beginner' },
      { text: 'Elementary', value: 'elementary' },
      { text: 'Intermediate', value: 'intermediate' },
      { text: 'Upper Intermediate', value: 'upper_intermediate' },
      { text: 'Advanced', value: 'advanced' },
      { text: 'Fluent', value: 'fluent' },
      { text: 'Native', value: 'native' }
    ],
    submitting: false
  }),
  computed: {
    languageProficiencies() {
      return this.otherInfo.language_proficiencies || [];
    }
  },
  watch: {
    userOthersInfoData: {
      handler(data) {
        const otherInfo = data?.data || data || {};
        this.otherInfo = {
          ...createOtherInfo(),
          ...otherInfo,
          language_proficiencies: (otherInfo.language_proficiencies || []).map((language) => ({
            ...createLanguage(),
            ...language
          }))
        };

        if (this.otherInfo.language_proficiencies.length === 0) {
          this.addLanguage();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    addLanguage() {
      this.otherInfo.language_proficiencies.push(createLanguage());
    },
    removeLanguage(index) {
      if (this.otherInfo.language_proficiencies.length > 1) {
        this.otherInfo.language_proficiencies.splice(index, 1);
      }
    }
  },
  setup(props) {
    const store = useStore();
    const otherInfo = ref(createOtherInfo());
    const submitting = ref(false);
    const { handleSubmit } = useForm({
      validationSchema: yup.object({})
    });

    const submit = handleSubmit(async () => {
      submitting.value = true;
      try {
        const response = await store.dispatch('otherInfo/saveEmployeeOtherInfo', {
          employeeId: props.employeeId || otherInfo.value.employee_id,
          otherInfoData: otherInfo.value
        });

        toast.success(response?.data?.message || 'Other information updated successfully', {
          timeout: 3000
        });
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to update other information');
      } finally {
        submitting.value = false;
      }
    });

    return {
      otherInfo,
      submitting,
      submit
    };
  }
};
</script>

<style scoped>
.language-table {
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.language-row {
  min-width: 700px;
  border-bottom: 1px solid #f0f0f0;
}

.language-header {
  background-color: #f8f9fa;
  font-size: 0.8rem;
  font-weight: 700;
}

.language-row > .v-col {
  padding: 8px;
}
</style>
